module.exports = __webpack_public_path__ + "img/tree_layer_5_deco_3.710255db.png";